<app-page-header headerImage="{{ headerImage }}" extraClass="homepage"></app-page-header>
<div class="core-content">

  @if (accountDetails && accountDetails.badDebt) {
  <div class="home-content_service-calendar content-wrapper u-space-v_30">
    <div class="home-content_heading">
      <h2 class="mat-display-medium">Balance overdue</h2>
    </div>
    <app-account-balance-card></app-account-balance-card>
  </div>
  }

  <div class="u-space-v_30">
    <div class="u-space-v_30">
      <app-marketing-banner-carousel [services]="recommendedCards"></app-marketing-banner-carousel>
    </div>

    <div class="home-content_thumbnail-cards_container">
      <div class="home-content_thumbnail-cards_heading">
        <h1 class="mat-display-small">Quick booking</h1>
      </div>
      <div class="quick-booking-container">
        @if (thumbnailCards) {
        <div class="swiper-custom-prev quick-booking-prev"></div>
        <div class="swiper-custom-next quick-booking-next"></div>
        <div class="swiper s-wrapper home-content_thumbnail-cards">
          <swiper-container class="swiper-wrapper home-override" [ngClass.lt-sm]="{ 'margin-right_30': true }"
            touch-action="none" data-swiper-parallax="100%" [direction]="configQuickBooking.direction"
            [initialSlide]="configQuickBooking.initialSlide" [slidesPerView]="configQuickBooking.slidesPerView"
            [spaceBetween]="configQuickBooking.spaceBetween"
            navigation='{ "nextEl": ".quick-booking-next", "prevEl": ".quick-booking-prev" }'
            [breakpoints]="configQuickBooking.breakpoints" (swiperTouchStart)="handleTouchStart($event)"
            (swiperTouchMoveOpposite)="swiperTouch($event)">
            @for (thumbnailCard of thumbnailCards; track thumbnailCard.cardText) {
            <swiper-slide>
              <app-thumbnail-icon-card (click)="
                              viewService(
                                thumbnailCard.cardText,
                                'quick booking',
                                thumbnailCard.cardText
                              )
                            " thumbnail="{{ thumbnailCard.cardImage }}"
                text="{{ thumbnailCard.cardText }}"></app-thumbnail-icon-card>
            </swiper-slide>
            }
          </swiper-container>
        </div>
        }
      </div>
    </div>

    <div class="home-content_dog-summary content-wrapper u-space-v_30">
      <app-dog-summary-card></app-dog-summary-card>
    </div>

    <div class="home-content_photos u-space-v_30">
      <app-photo-carousel heading="Recent photos"></app-photo-carousel>
    </div>

    <div class="home-content_service-calendar content-wrapper u-space-v_30">
      <div class="home-content_service-calendar_heading">
        <h2 class="mat-display-medium">Services calendar</h2>
      </div>
      <div class="home-content_service-calendar_container">
        <app-service-calendar page="home"></app-service-calendar>
      </div>
    </div>

    <div class="home-content_recommended_container content-wrapper u-space-v_30">
      <div class="home-content_heading">
        <h2 class="mat-display-medium">Recommended for you</h2>
        <div class="home-content_recommended_heading-action">
          <app-arrow-text-button linkPath="test()" [routerLink]="userActive ? ['/services/booking'] : ''"
            (click)="googleEvent('recommended for you', 'view all')">
            <div linkText>view all</div>
          </app-arrow-text-button>
        </div>
      </div>

      @if (!recommendedHasData) {
      <div class="u-flex-center">
        <mat-spinner color="primary" diameter="50"></mat-spinner>
      </div>
      }

      @if (recommendedHasData && recommendedCards) {
      @if (recommendedCards.length > 4) {
      <div class="swiper-custom-prev recommended-prev"></div>
      <div class="swiper-custom-next recommended-next"></div>
      }
      @if (recommendedCards.length > 0) {
      <div class="home-content_recommended">
        <swiper-container class="swiper-container-home-page" touch-action="none" [direction]="configRecommended.direction"
          [initialSlide]="configRecommended.initialSlide" [slidesPerView]="configRecommended.slidesPerView"
          [spaceBetween]="configRecommended.spaceBetween"
          navigation='{ "nextEl": ".recommended-next", "prevEl": ".recommended-prev" }'
          [breakpoints]="configRecommended.breakpoints" (swiperTouchStart)="handleTouchStart($event)"
          (swiperTouchMoveOpposite)="swiperTouch($event)">
          @for (card of recommendedCards; track card.title; let i = $index) {
          <swiper-slide>
            <app-medium-image-card layout="vertical" [hasOverlay]="card.overlayText" [overlayText]="card.overlayText"
              [hasNotification]="card.cardNotification"
              [cardNotification]="card.cardNotification ? card.cardNotification : ''"
              [bannerImage]="card.image != null ? card.image : placeholder" [cardText]="card.serviceDescription"
              [cardPrice]="card.price" class="override-margin">
              <h2 card-title class="mat-body-medium">{{ card.title }}</h2>
              <button (click)="viewService(i + 2, 'recommended for you', 'request')" card-button mat-raised-button color="primary"
                class="medium-image-card_button">
                Request
              </button>
              </app-medium-image-card>
              </swiper-slide>
              }
              </swiper-container>
              </div>
              }
              }
    </div>

    @if (bookAgainCards.length > 0) {
    <div class="home-content_recommended_container content-wrapper u-space-v_30">
      <div class="home-content_heading">
        <h2 class="mat-display-medium">Book again</h2>
        @if (bookAgainCards.length > 4) {
        <div class="home-content_recommended_heading-action">
          <app-arrow-text-button linkPath="test()">
            <div linkText>view all</div>
          </app-arrow-text-button>
        </div>
        }
        </div>

      @if (!bookAgainHasData) {
      <div class="u-flex-center">
        <mat-spinner color="primary" diameter="50"></mat-spinner>
      </div>
      }

      @if (bookAgainHasData) {
      <div class="home-content_recommended">
        @if (bookAgainCards.length > 4) {
        <div class="swiper-custom-prev book-again-prev"></div>
        <div class="swiper-custom-next book-again-next"></div>
        }
        <swiper-container class="swiper-container-home-page" touch-action="none" [direction]="configBookAgain.direction"
          [initialSlide]="configBookAgain.initialSlide" [slidesPerView]="configBookAgain.slidesPerView"
          [spaceBetween]="configBookAgain.spaceBetween"
          navigation='{ "nextEl": ".book-again-next", "prevEl": ".book-again-prev" }'
          [breakpoints]="configBookAgain.breakpoints" (swiperTouchStart)="handleTouchStart($event)"
          (swiperTouchMoveOpposite)="swiperTouch($event)">

          @for (card of bookAgainCards; track card.sliderIndex; let i = $index) {
          <swiper-slide>
            <app-medium-image-card layout="vertical" [hasOverlay]="card.overlayText" [overlayText]="card.overlayText"
              [hasNotification]="card.cardNotification"
              [cardNotification]="card.cardNotification ? card.cardNotification : ''"
              [bannerImage]="card.image != null ? card.image : placeholder" [cardText]="card.serviceDescription"
              [cardPrice]="card.price" class="book-again">
              <h2 card-title class="mat-body-medium">{{ card.title }}</h2>
              <button (click)="viewService(card.sliderIndex + 2, 'book again', 'request')" card-button mat-raised-button
                color="primary" class="medium-image-card_button">
                Request
              </button>
            </app-medium-image-card>
          </swiper-slide>
          }
        </swiper-container>
      </div>
      }
      </div>
    }
  </div>
  @if (benefitsHasData && benefitCards) {
  <div class="home-content_recommended_container content-wrapper u-space-v_30">
    <div class="home-content_heading">
      <h2 class="mat-display-medium">Bruce's Benefits</h2>
      <div class="home-content_recommended_heading-action">
        <app-arrow-text-button [routerLink]="userActive ? ['/benefits'] : ''"
          (click)="googleEvent('benefits', 'view all')">
          <div linkText>view all</div>
        </app-arrow-text-button>
      </div>
    </div>

    @if (!benefitsHasData) {
    <div class="u-flex-center">
      <mat-spinner color="primary" diameter="50"></mat-spinner>
    </div>
    }

    @if (benefitCards.length > 4) {
    <div class="swiper-custom-prev benefits-prev"></div>
    <div class="swiper-custom-next benefits-next"></div>
    }
    @if (benefitCards.length > 0) {
    <div class="home-content_recommended">
      <swiper-container class="swiper-container-home-page" touch-action="none" [direction]="configBenefits.direction"
        [initialSlide]="configBenefits.initialSlide" [slidesPerView]="configBenefits.slidesPerView"
        [spaceBetween]="configBenefits.spaceBetween" navigation='{ "nextEl": ".benefits-next", "prevEl": ".benefits-prev" }'
        [breakpoints]="configBenefits.breakpoints" (swiperTouchStart)="handleTouchStart($event)"
        (swiperTouchMoveOpposite)="swiperTouch($event)">
        @for (card of benefitCards; track card.offer_code; let i = $index) {
        <swiper-slide>
          <app-benefit-image-card layout="vertical" [bannerImage]="card.image != null ? card.image : placeholder"
            [cardText]="card.description" [cardCode]="card.offer_code" class="benefit-card override-margin">
            <h2 card-title class="mat-body-medium" [class.long-title]="card.title.length > 28" [title]="card.title">
              {{ card.title }}
            </h2>
            <button (click)="goToUrl(card.button_link); googleEvent('Benefit', card.title)" card-button mat-raised-button
              color="primary">
              {{ card.button_text }}
            </button>
            </app-benefit-image-card>
            </swiper-slide>
            }
      </swiper-container>
    </div>
    }
  </div>
  }
</div>